/**
 * ? Admin Profile Page Component
 */

// Dependencies
import React, { Fragment, useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../axios/Axios";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";

// MUI Icons
import { Edit } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import axios from "axios";

function ProfilePage() {
  // * Redux COmponent
  const dispatch = useDispatch();

  const userId = sessionStorage.getItem("user_id");

  // * State Variables
  const [editIconButton, setEditIconButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState({
    first_name: "",
    last_name: "",
    phone_no: "",
    email_id: ""
  });

  const [firstNameError, setFirstNameError] = useState({
    error: false,
    message: "",
  });
  const [lastNameError, setLastNameError] = useState({
    error: false,
    message: "",
  });
  
  const [phoneNumberError, setPhoneNumberError] = useState({
    error: false,
    message: "",
  });
  const [emailError, setEmailError] = useState({
    error: false,
    message: "",
  });
 // TODO : Mobile number Validation Pattern
 const checkInvalidNumber = (number) => {
  var pattern = new RegExp(
   /^(?:(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9})$/
  );
  var result = pattern.test(number);
  return !result;
   }

  //Form validation function 
  function checkFormData() {
    let isFormDataValid = true;

    if (adminData.first_name.length === 0 || adminData.first_name.length > 20) {
      isFormDataValid = false;
      setFirstNameError({
        ...firstNameError,
        error: true,
        message: "First name is required and characters must be less than 20.",
      });
    }

    if (adminData.last_name.length === 0 || adminData.last_name.length > 20) {
      isFormDataValid = false;
      setLastNameError({
        ...lastNameError,
        error: true,
        message: "Last name is required and characters must be less than 20.",
      });
    }

    if (!(adminData.phone_no.length === 10  ) ) {
      isFormDataValid = false;
      setPhoneNumberError({
        ...phoneNumberError,
        error: true,
        message:
          "Phone number is required and must be a valid 10 digits number.",
      });
    } else {
      if (checkInvalidNumber(adminData.phone_no)){
        isFormDataValid = false;
        setPhoneNumberError({
          ...phoneNumberError,
          error: true,
          message:
            "Phone number is required only numeric value.",
        });
      }
    }

    if (adminData.email_id.length === 0) {
      isFormDataValid = false;
      setEmailError({
        ...emailError,
        error: true,
        message: "Email Id is required.",
      });
    } else {

      let pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      let result = pattern.test(adminData.email_id);

      if(!result){
        isFormDataValid = false;
        setEmailError({
          ...emailError,
          error: true,
          message: "Enter valid email id.",
        });
      }
      
    }

    return isFormDataValid;
  }

  // ? API Call : Fetch Admin Details
  useEffect(() => {
    // TODO : Data Fetching
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        const options = {
          method: "get",
          url: `adminlogin/${userId}`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );

        const {data} = response;
        
          setAdminData({
            first_name: data.first_name,
            last_name: data.last_name,
            phone_no: data.phone_no,
            email_id: data.email_id
          })

      } catch (error) {
        if(!axios.isCancel(error)){
          console.log(error);
          dispatch(
            showSnackbar({
              message: "Error occurred! Unable to fetch admin data.",
              severity: "error",
            })
          );
        }
       
      }
    })()
    return () => {
      controller.cancel();
  }
  },[userId, dispatch]);
  // console.log(adminData);

  // handle onchange events
  function handleChange(event){
    const {value, name} = event.target;
    setAdminData(prevState => ({...prevState, [name]: value}))
  }

  //Put Request: To update admin profile data
  const PutAdminData = async () => {
    const isDataValidated = checkFormData();
    
    if(isDataValidated){
      setLoading(true);
      try{
        const options = {
          method: "put",
          url: `adminlogin/updateadmin/${userId}`,
          auth: true,
          data: adminData,
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
  
        if(response.status === 200){
          setEditIconButton(false);
          setLoading(false);
          // window.location.reload();
          // console.log(response);
          dispatch(
            showSnackbar({
              message: "Changes saved successfully !",
              severity: "success",
            })
          );
        }
      }catch(error){
        setLoading(false);
        console.log(error);
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable save changes.",
            severity: "error",
          })
        );
      }
    }
  }

  return (
    <Fragment>
      {/* Title */}
      <Box
        sx={{
          mt: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ mr: "16px" }}>
          <Typography variant="h5" component="div">
            Profile Page
          </Typography>
        </Box>

        <Box>
          <IconButton onClick={() => setEditIconButton(true)}>
            <Tooltip arrow placement="right" title="Edit">
              <Edit />
            </Tooltip>
          </IconButton>
        </Box>
      </Box>

      {/* Input Fields */}
      <Box
        sx={{
          mt: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mt: "16px" }}>
            <Box>
              <Typography variant="p" component="div">
                First Name
              </Typography>
              <TextField
                disabled={!editIconButton}
                type="text"
                id="firstName"
                name="first_name"
                size="small"
                variant="outlined"
                sx={{ 
                  width: 242, 
                  mr: "16px", 
                  mt: "8px",
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }}
                value={adminData.first_name}
                onChange={(e) => {
                  handleChange(e);
                  setFirstNameError({error: false, message: ""})
                }}
                error={firstNameError.error}
                helperText={firstNameError.error && firstNameError.message}
              />
            </Box>

            <Box>
              <Typography variant="p" component="div">
                Last Name
              </Typography>
              <TextField
                disabled={!editIconButton}
                type="text"
                id="lastName"
                name="last_name"
                size="small"
                variant="outlined"
                sx={{ width: 242, mt: "8px", '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                value={adminData.last_name}
                onChange={(e) => {
                  handleChange(e);
                  setLastNameError({error: false, message: ""});
                }
                }
                error={lastNameError.error}
                helperText={lastNameError.error && lastNameError.message}
              />
            </Box>
          </Box>
        </Box>

        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Box>
            <Typography variant="p" component="div">
              Username
            </Typography>

            <Box sx={{ mt: "8px" }}>
              <TextField
                disabled={!editIconButton}
                type="tel"
                id="username"
                name="username"
                size="small"
                variant="outlined"
                sx={{ width: 500, '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                value={adminData.username}
                onChange={handleChange}
              />
            </Box>
          </Box>
        </Box> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Box>
            <Typography variant="p" component="div">
              Phone Number
            </Typography>

            <Box sx={{ mt: "8px" }}>
              <TextField
                disabled={!editIconButton}
                type="tel"
                id="phoneNumber"
                name="phone_no"
                size="small"
                variant="outlined"
                sx={{ width: 500, '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                value={adminData.phone_no}
                onChange={(e) => {
                  handleChange(e);
                  setPhoneNumberError({error: false, message: ""})
                }}
                error={phoneNumberError.error}
                helperText={phoneNumberError.error && phoneNumberError.message}
              />
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: "16px",
          }}
        >
          <Box>
            <Typography variant="p" component="div">
              Email Id
            </Typography>

            <Box sx={{ mt: "8px" }}>
              <TextField
                disabled={!editIconButton}
                type="email"
                id="email"
                name="email_id"
                size="small"
                variant="outlined"
                sx={{ width: 500, '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                value={adminData.email_id}
                onChange={(e) => {
                  handleChange(e);
                  setEmailError({error: false, message: ""})
                }}
                error={emailError.error}
                helperText={emailError.error && emailError.message}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Buttons */}
      <Box
        sx={{
          display: `${editIconButton ? "flex" : "none"}`,
          alignItems: "center",
          justifyContent: "center",
          mt: "16px",
          mb: "16px",
        }}
      >
        <Button
          type="button"
          variant="contained"
          color="inherit"
          sx={{ mr: "16px" }}
          onClick={() => setEditIconButton(!editIconButton)}
        >
          cancel
        </Button>

        <LoadingButton 
          type="submit"
          loading={loading} 
          variant="contained" 
          color="primary"
          onClick={PutAdminData}
        >
          submit
        </LoadingButton>
      </Box>
    </Fragment>
  );
}

export default ProfilePage;
